import Translate from "@casino/legacy/client/shared/i18n/Translate";

type Props = {
  translateId?: string;
};

const PageTitle: FC<Props> = ({ translateId, children }) => (
  <h1 className="z-2 self-end text-2xl text-foreground">
    {translateId ? <Translate id={translateId} /> : children}
  </h1>
);

export default PageTitle;
